import { TFunction } from 'i18next';

export interface IQuizForm {
  locationsCount: string;
  monthlyCustomers: string;
  reviewPlatforms: string[];
  otherReviewPlatforms: string;
  crmPlatforms: string[];
  otherCrmPlatforms: string;
  interestedSolutions: string[];
  otherInterestedSolutions: string;
  isUseReviewManagers: string;
  otherReviewManagers: string;
}

const generateQuizResponse = (quizAnswers: Partial<IQuizForm>, t: TFunction) => {
  const currentSoftware = quizAnswers.crmPlatforms || quizAnswers.reviewPlatforms || [];
  const locationCount = quizAnswers.locationsCount || '';
  const interestedSolutions = quizAnswers.interestedSolutions || [];

  let integrationPart = '';
  let locationPart = '';
  let comingSoonPart = '';

  if (currentSoftware.length > 0) {
    const softwareList = [...currentSoftware];
    integrationPart = `${t('mainPage.newCustomerForm.finalStep.integrationWith')} ${softwareList.join(', ')}`;
  } else {
    integrationPart = t('mainPage.newCustomerForm.finalStep.manualRequests');
  }

  if (locationCount) {
    if (locationCount === '1') {
      locationPart = t('mainPage.newCustomerForm.finalStep.singleLocation');
    } else {
      locationPart = t('mainPage.newCustomerForm.finalStep.allLocations');
    }
  }

  const comingSoonFeatures = [
    'Customer Surveys (NPS)',
    'Listings Management',
    'Competitor Review Monitoring',
  ];

  const selectedComingSoon = interestedSolutions.filter((solution) =>
    comingSoonFeatures.includes(solution),
  );

  if (selectedComingSoon.length > 0) {
    comingSoonPart = `${t('mainPage.newCustomerForm.finalStep.comingSoon')} ${selectedComingSoon.join(' and ')} ${t('mainPage.newCustomerForm.finalStep.willBeComingSoon')}`;
  }

  let response = `${integrationPart} ${t('mainPage.newCustomerForm.finalStep.automatesReviews')} ${locationPart}.`;

  if (comingSoonPart) {
    response += ` ${comingSoonPart}.`;
  }

  response += `\n${t('mainPage.newCustomerForm.finalStep.startTrial')}`;

  return response;
};

export default generateQuizResponse;
